import React from 'react'
import { useTelegram } from './telegram'

export const useTelegramRedirect = () => {
  const { start } = useTelegram()

  const redirectUrl = React.useMemo(() => {
    const { params } = start
    if (!params) return null

    return params.redirect_url ?? null
  }, [start])

  React.useEffect(() => {
    if (!redirectUrl) return

    // create a new URL using the current one as a base, and just change the pathname
    const url = new URL(window.location.href)
    url.pathname = redirectUrl

    // don't redirect if already there
    if (location.pathname === url.pathname) return

    // FIXME: For some reason useHistory().push doesn't work, which is why we're overwriting href
    window.location.href = url.href
  }, [redirectUrl])
}
